import { render, staticRenderFns } from "./ServiceOrdersReport.vue?vue&type=template&id=944dd926&scoped=true&"
import script from "./ServiceOrdersReport.vue?vue&type=script&lang=js&"
export * from "./ServiceOrdersReport.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrdersReport.vue?vue&type=style&index=0&id=944dd926&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944dd926",
  null
  
)

export default component.exports